import { ROLE_INTERNAL_DOCTOR } from "@/types/role";

/**
 * Para onde mandar alguém que precisa ir "para casa": entrada da sessão, guard
 * que nega e 403 de leitura de página.
 *
 * Uma função, três consumidores. A exceção do médico interno (a home composta
 * NÃO é dele — ADR home-composta-inicio) vivia em dois comentários e um lugar
 * só; foi exatamente assim que o `useSwitchUser` pousou o interno na home vazia
 * (G7 reaberto em 2026-07-27).
 */
export function homePathFor(
  user?: { role_id?: number | null } | null,
): string {
  return user?.role_id === ROLE_INTERNAL_DOCTOR
    ? "/formulario-interno"
    : "/inicio";
}
